@let parameterValue = parameter();
@if (parameterValue.indexOf('tt') > -1 || parameterValue === 'td') {
  <table class="legend-table">
    <tr>
      <td>&lt;-4</td>
      <td>-3</td>
      <td>-2</td>
      <td>-1.25</td>
      <td>-0.75</td>
      <td>-0.25</td>
    </tr>
    <tr>
      <td style="background-color: #000000" class="legend-color"></td>
      <td style="background-color: #0000ff" class="legend-color"></td>
      <td style="background-color: #007fff" class="legend-color"></td>
      <td style="background-color: #3ec0ff" class="legend-color"></td>
      <td style="background-color: #00ae00" class="legend-color"></td>
      <td style="background-color: #00ff00" class="legend-color"></td>
    </tr>
    <tr>
      <td>0.25</td>
      <td>0.75</td>
      <td>1.25</td>
      <td>2</td>
      <td>&lt;3</td>
      <td>&ge;3°C</td>
    </tr>
    <tr>
      <td style="background-color: #d0d0d0" class="legend-color"></td>
      <td style="background-color: #ffff00" class="legend-color"></td>
      <td style="background-color: #ff7f00" class="legend-color"></td>
      <td style="background-color: #ff0000" class="legend-color"></td>
      <td style="background-color: #c80032" class="legend-color"></td>
      <td style="background-color: #960096" class="legend-color"></td>
    </tr>
  </table>
}

@if (parameterValue === 'road_condition') {
  <table class="legend-table">
    <tr>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.dry' | translate }}</td>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.wet' | translate }}</td>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.blackIce' | translate }}</td>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.unknown' | translate }}</td>
    </tr>
    <tr>
      <td style="background-color: #00ff00" class="legend-color"></td>
      <td style="background-color: #0000ff" class="legend-color"></td>
      <td style="background-color: #ff0000" class="legend-color"></td>
      <td style="background-color: #d0d0d0" class="legend-color"></td>
    </tr>
  </table>
}

@if (parameterValue.indexOf('wft') > -1) {
  <table class="legend-table">
    <tr>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.dry' | translate }}</td>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.wet' | translate }}</td>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.wet' | translate }}</td>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.wet' | translate }}</td>
    </tr>
    <tr>
      <td>&nbsp;<br />(0...10)</td>
      <td>{{ 'PRODUCT.MARWIS.LEGEND.level' | translate }} 1<br />(10..100)</td>
      <td>
        {{ 'PRODUCT.MARWIS.LEGEND.level' | translate }} 2<br />(100..1000)
      </td>
      <td>
        {{ 'PRODUCT.MARWIS.LEGEND.level' | translate }} 3<br />(1000..10000)
      </td>
    </tr>
    <tr>
      <td style="background-color: #008000" class="legend-color"></td>
      <td style="background-color: #87cefa" class="legend-color"></td>
      <td style="background-color: #00bfff" class="legend-color"></td>
      <td style="background-color: #dc143c" class="legend-color"></td>
    </tr>
  </table>
}

@if (parameterValue.indexOf('rh') > -1) {
  <table class="legend-table">
    <tr>
      <td>0..10%</td>
      <td>10..20%</td>
      <td>20..30%</td>
      <td>30..40%</td>
      <td>40..50%</td>
    </tr>
    <tr>
      <td style="background-color: #a26b3c" class="legend-color"></td>
      <td style="background-color: #b77e53" class="legend-color"></td>
      <td style="background-color: #cc9b7a" class="legend-color"></td>
      <td style="background-color: #d8af97" class="legend-color"></td>
      <td style="background-color: #f2dacd" class="legend-color"></td>
    </tr>

    <tr>
      <td>50..60%</td>
      <td>60..70%</td>
      <td>70..80%</td>
      <td>80..90%</td>
      <td>90..100%</td>
    </tr>
    <tr>
      <td style="background-color: #ccfdff" class="legend-color"></td>
      <td style="background-color: #99f8ff" class="legend-color"></td>
      <td style="background-color: #65efff" class="legend-color"></td>
      <td style="background-color: #32e3ff" class="legend-color"></td>
      <td style="background-color: #00bfe9" class="legend-color"></td>
    </tr>

    <!--
    <tr><td style="background-color: #CCFDFF;" class="legend-color"></td><td> &nbsp; 50...60{{ 'PRODUCT.MARWIS.UNIT.rh' | translate }}</td></tr>
    <tr><td style="background-color: #99F8FF;" class="legend-color"></td><td> &nbsp; 60...70{{ 'PRODUCT.MARWIS.UNIT.rh' | translate }}</td></tr>
    <tr><td style="background-color: #65EFFF;" class="legend-color"></td><td> &nbsp; 70...80{{ 'PRODUCT.MARWIS.UNIT.rh' | translate }}</td></tr>
    <tr><td style="background-color: #32E3FF;" class="legend-color"></td><td> &nbsp; 80...90{{ 'PRODUCT.MARWIS.UNIT.rh' | translate }}</td></tr>
    <tr><td style="background-color: #00BFE9;" class="legend-color"></td><td> &nbsp; 90...100{{ 'PRODUCT.MARWIS.UNIT.rh' | translate }}</td></tr>
    -->
  </table>
}
